import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import confettiImage from './images/confetti.svg';
import { VariableRate } from '../../../../ui/rate';

type OfferModalProps = {
    creditLimit: number;
    apr: number;
    cashbackRate: number;
    onMaybeLater: () => void;
    onContinue: () => void;
};

export const OfferModal = ({
    creditLimit,
    apr,
    cashbackRate,
    onMaybeLater,
    onContinue
}: OfferModalProps) => {
    return (
        <div className="flex flex-col items-center gap-xl px-xl py-2xl text-center">
            <div className="relative flex h-[96px] w-full items-center justify-center overflow-hidden">
                <img
                    src={confettiImage}
                    alt=""
                    aria-hidden="true"
                    className="pointer-events-none absolute inset-0 h-full w-full select-none object-cover object-top"
                />
                <Text className="relative text-3xl font-bold text-primary-10">
                    <FormattedMessage
                        id="_.credit_card_waitlist.offer.title"
                        defaultMessage="Your personalised offer"
                    />
                </Text>
            </div>

            <div className="w-full border-t border-secondary-90 pt-l">
                <Text className="text-m font-reg text-structure-40">
                    <FormattedMessage
                        id="_.credit_card_waitlist.offer.details_intro"
                        defaultMessage="Here's your personalised credit card offer:"
                    />
                </Text>
                <div className="flex items-stretch py-l">
                    <div className="flex-1 border-r border-secondary-90 px-m">
                        <Text className="text-xl font-med text-primary-10">
                            <FormattedCurrency
                                value={creditLimit}
                                decimalPlaces={0}
                            />{' '}
                            <FormattedMessage
                                id="_.credit_card_waitlist.offer.limit_label"
                                defaultMessage="limit"
                            />
                        </Text>
                    </div>
                    <div className="flex-1 border-r border-secondary-90 px-m">
                        <Text className="text-xl font-med text-primary-10">
                            <VariableRate
                                value={apr}
                                maximumFractionDigits={1}
                                minimumFractionDigits={1}
                            />{' '}
                            <FormattedMessage
                                id="_.credit_card_waitlist.offer.apr_label"
                                defaultMessage="APR"
                            />
                        </Text>
                    </div>
                    <div className="flex-1 px-m">
                        <Text className="text-xl font-med text-primary-10">
                            <VariableRate
                                value={cashbackRate}
                                maximumFractionDigits={0}
                                minimumFractionDigits={0}
                            />{' '}
                            <FormattedMessage
                                id="_.credit_card_waitlist.offer.cashback_label"
                                defaultMessage="cashback"
                            />
                        </Text>
                    </div>
                </div>
                <Text className="border-t border-secondary-90 pt-l text-m text-structure-40">
                    <FormattedMessage
                        id="_.credit_card_waitlist.offer.email_notice"
                        defaultMessage="We'll email you this offer – it's valid for 45 days, after which you'll need to reapply."
                    />
                </Text>
            </div>

            <div className="flex flex-col gap-2xs">
                <Text className="text-l font-bold text-primary-10">
                    <FormattedMessage
                        id="_.credit_card_waitlist.offer.activate_title"
                        defaultMessage="Let's get your card activated"
                    />
                </Text>
                <Text className="text-m font-reg text-structure-40">
                    <FormattedMessage
                        id="_.credit_card_waitlist.offer.activate_body"
                        defaultMessage="We've pre-filled your details from your Flexi-Loan to make card activation easier."
                    />
                </Text>
            </div>

            <div className="flex flex-col items-center gap-m">
                <button
                    onClick={onContinue}
                    className="rounded-full px-xl py-m text-m font-med text-white transition-colors"
                    style={{ backgroundColor: '#07172b' }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#0a1f3a';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#07172b';
                    }}
                >
                    <FormattedMessage
                        id="_.credit_card_waitlist.offer.cta_continue"
                        defaultMessage="Finish your application"
                    />
                </button>
                <button
                    onClick={onMaybeLater}
                    className="hover:text-primary-30 text-m font-med text-primary-40 transition-colors"
                >
                    <FormattedMessage
                        id="_.credit_card_waitlist.offer.cta_maybe_later"
                        defaultMessage="Maybe later"
                    />
                </button>
            </div>
        </div>
    );
};
